export const RoomKinds =
	[
		{ value: 'webinar', label: 'Webinar' },
		{ value: 'conference', label: 'Conference' }
		// { value: 'p2p', label: 'P2p' }
	];

export const RecurringType =
	[
		{ value: 'monthly', label: 'Monthly' },
		{ value: 'weekly', label: 'Weekly' },
		{ value: 'daily', label: 'Daily' }
	];

export const Languages = [
	{ value: 'en', label: 'English' },
	{ value: 'zh', label: 'Chinese' },
	{ value: 'es', label: 'Español' },
	{ value: 'ph', label: 'Filipino' }
];

export const TIME_FORMAT = [
	{ value: true, label: '24-hrs format' },
	{ value: false, label: '12-hrs format' }
];

const { videoAspectRatio = 1.777 } = window.config;

export const VIDEO_CONSTRAINS = {
	low: {
		width: { ideal: 320 },
		aspectRatio: videoAspectRatio
	},
	medium: {
		width: { ideal: 640 },
		aspectRatio: videoAspectRatio
	},
	high: {
		width: { ideal: 1280 },
		aspectRatio: videoAspectRatio
	},
	veryhigh: {
		width: { ideal: 1920 },
		aspectRatio: videoAspectRatio
	},
	ultra: {
		width: { ideal: 3840 },
		aspectRatio: videoAspectRatio
	}
};
export const UserRoles = [
	{ value: 'member', label: 'Member' },
	{ value: 'participant', label: 'Participant' }
];

export const STT_AUDIO_SAMPLE_RATE = 48_000;

export const AudioContext =
  window.AudioContext || // our preferred impl
  window.webkitAudioContext || // fallback, mostly when on Safari
  false; // could not find.

export const IS_AUDIOWORKLET_AVAILABLE = window.AudioWorkletNode ? true : false;

export const userRoles =
{
	AUDIENCE: 6061,
	ADMIN: 2529,
	MODERATOR: 5337,
	PRESENTER: 9583,
	NORMAL: 4261
};

export const BREAKOUT_TIME_LIMIT = 2700;

export const TAB_INDEX = [
	{ tabIndex: 0, tabValue: 'past' },
	{ tabIndex: 1, tabValue: 'present' },
	{ tabIndex: 2, tabValue: 'future' }
];